import { render } from "./ProspectsHoje.vue?vue&type=template&id=4328ec6d&scoped=true"
import script from "./ProspectsHoje.vue?vue&type=script&lang=js"
export * from "./ProspectsHoje.vue?vue&type=script&lang=js"

import "./ProspectsHoje.vue?vue&type=style&index=0&id=4328ec6d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4328ec6d"]])

export default __exports__